import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';
import getFetchOptions from 'utils/getFetchOptions';

export default function updateTestAdminMunicipality(testAdmin) {
	return fetch(
		`${ENDPOINT_URL}/updatetestadminmunicipality`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(testAdmin),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
